import { render, staticRenderFns } from "./data-queries.vue?vue&type=template&id=398362a6&"
import script from "./data-queries.vue?vue&type=script&lang=js&"
export * from "./data-queries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "data-queries.vue"
export default component.exports